import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { ApiMeta } from '../../_core/_model/api-response';
import { ApiService } from '../../_core/_services/api.service';
import { FormatService } from '../../_core/_services/format';
import { NotificationService } from '../../_core/_services/notification.service';
import { CreateCurrencyDto, CurrencyDetailsDto } from '../../_core/_model/currency';
import { Router } from '@angular/router';

@Component({
  selector: 'app-currencies',
  standalone: false,
  templateUrl: './currencies.html',
  styleUrl: './currencies.css',
})
export class Currencies implements OnInit {
  currencies: CurrencyDetailsDto[] = [];
  metaCurrency: ApiMeta | null = null;
  loading = false;

  editModal?: Modal;
  loadingEdit = false;

  selectedCurrency: CurrencyDetailsDto | null = null;
  private currencyModal?: Modal;

  currencyPage: number = 1

  currencyForm: FormGroup;
  editCurrencyForm: FormGroup;
  
  deletingId: string | null = null;
  url: any;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private format: FormatService,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.currencyForm = this.fb.group({
      currencyName: ['', Validators.required],
      currencyCode: ['', [Validators.required, Validators.maxLength(3)]],
      symbol: ['', Validators.required],
      decimalPlaces: [0, [Validators.required, Validators.min(0)]],
      delimiter: ['', Validators.required],
      minDeposit: [0, [Validators.required, Validators.min(0)]],
      preKycMaxDeposit: [0, [Validators.required, Validators.min(0)]],
      minOrder: [0, [Validators.required, Validators.min(0)]],
      preKycMaxOrder: [0, [Validators.required, Validators.min(0)]],
      minWithdraw: [0, [Validators.required, Validators.min(0)]],
      preKycMaxWithdraw: [0, [Validators.required, Validators.min(0)]]
    });
    this.editCurrencyForm = this.fb.group({
      id: [''],
      currencyName: ['', Validators.required],
      symbol: ['', Validators.required],
      decimalPlaces: [0, [Validators.required, Validators.min(0)]],
      delimiter: ['', Validators.required],
      minDeposit: [0, [Validators.required, Validators.min(0)]],
      preKycMaxDeposit: [0, [Validators.required, Validators.min(0)]],
      minOrder: [0, [Validators.required, Validators.min(0)]],
      preKycMaxOrder: [0, [Validators.required, Validators.min(0)]],
      minWithdraw: [0, [Validators.required, Validators.min(0)]],
      preKycMaxWithdraw: [0, [Validators.required, Validators.min(0)]]
    });
    this.url = this.router.url.slice(1);
  }
  get currencyName() { return this.currencyForm.get('currencyName'); }
  get currencyCode() { return this.currencyForm.get('currencyCode'); }
  get symbol() { return this.currencyForm.get('symbol'); }
  get decimalPlaces() { return this.currencyForm.get('decimalPlaces'); }
  get delimiter() { return this.currencyForm.get('delimiter'); }
  get preKycMaxDeposit() { return this.currencyForm.get('preKycMaxDeposit'); }
  get minOrder() { return this.currencyForm.get('minOrder'); }
  get minWithdraw() { return this.currencyForm.get('minWithdraw'); }
  get preKycMaxOrder() { return this.currencyForm.get('preKycMaxOrder'); }
  get minDeposit() { return this.currencyForm.get('minDeposit'); }
  get preKycMaxWithdraw() { return this.currencyForm.get('preKycMaxWithdraw'); }

  get editCurrencyName() { return this.editCurrencyForm.get('currencyName'); }
  get editSymbol() { return this.editCurrencyForm.get('symbol'); }
  get editDecimalPlaces() { return this.editCurrencyForm.get('decimalPlaces'); }
  get editDelimiter() { return this.editCurrencyForm.get('delimiter'); }
  get editMinDeposit() { return this.editCurrencyForm.get('minDeposit'); }
  get editMinOrder() { return this.editCurrencyForm.get('minOrder'); }
  get editMinWithdraw() { return this.editCurrencyForm.get('minWithdraw'); }
  get editPreKycMaxDeposit() { return this.editCurrencyForm.get('preKycMaxDeposit'); }
  get editPreKycMaxOrder() { return this.editCurrencyForm.get('preKycMaxOrder'); }
  get editPreKycMaxWithdraw() { return this.editCurrencyForm.get('preKycMaxWithdraw'); }


  ngOnInit(): void {
    this.listCurrencies(this.currencyPage);
  }

  listCurrencies(currencyPage:number) {
    this.loading = true;
    this.api.getCurrencies(currencyPage).subscribe({
      next: (res) => {
        this.metaCurrency = res.meta;
        this.currencies = res.data || [];
      },
      error: (err) => {
        this.notifyService.showError(err.error?.Error?.Details || 'Failed to load currency', "Error");
      },
      complete: () => (this.loading = false),
    });
  }

  editCurrency(currency: CurrencyDetailsDto) {
    // populate
    this.editCurrencyForm.patchValue({
      id: currency.id,
      currencyName: currency.currencyName,
      symbol: currency.symbol,
      decimalPlaces: currency.decimalPlaces,
      delimiter: currency.delimiter,
      minDeposit: currency.minDeposit,
      preKycMaxDeposit: currency.preKycMaxDeposit,
      minOrder: currency.minOrder,
      preKycMaxOrder: currency.preKycMaxOrder,
      minWithdraw: currency.minWithdraw,
      preKycMaxWithdraw: currency.preKycMaxWithdraw
    });

    // show modal
    const el = document.getElementById('editCurrencyModal');
    if (!el) return;

    this.editModal = Modal.getOrCreateInstance(el);
    this.editModal.show();
  }


  closeEditModal() {
    this.editModal?.hide();
  }

  saveCurrencyEdits() {
    if (this.editCurrencyForm.invalid) {
      this.editCurrencyForm.markAllAsTouched();
      return;
    }
    
    const updatedCurrency = this.editCurrencyForm.getRawValue(); 

    this.loadingEdit = true;

    this.api.updateCurrency(updatedCurrency).subscribe({
      next: (res) => {
        const index = this.currencies.findIndex(c => c.id === updatedCurrency.id);
        if (index !== -1) {
          this.currencies[index] = res.data!;
        }
        this.notifyService.showSuccess('Currency updated successfully', "Success");
        this.closeEditModal();
      },
      error: (err) => {
        this.notifyService.showError(err.error?.Error?.Details || 'Failed to update currency', "Error");
      },
      complete: () => (this.loadingEdit = false),
    }); 
  }

  deleteCurrency(currencyId: string) {
    const currency = this.currencies.find(c => c.id === currencyId);
    this.deletingId = currency!.id;
    if (confirm(`Are you sure you want to delete ${currency?.currencyName}? This action cannot be undone.`)) {
      this.api.deleteCurrency(currency!.id).subscribe({
        next: () => {
          this.currencies = this.currencies.filter(c => c.id !== currency!.id);
          this.notifyService.showSuccess("Currency Deleted", "Success");
        },
        error: (err) => {
          this.notifyService.showError(err.error?.Error?.Details || 'Failed to delete currency', "Error");
        }
      });
    }
  }

  addCurrency() {
    if (this.currencyForm.invalid) return;

    const newCurrency: CreateCurrencyDto = {
      currencyName: this.currencyName?.value,
      currencyCode: this.currencyCode?.value,
      symbol: this.symbol?.value,
      decimalPlaces: this.decimalPlaces?.value,
      delimiter: this.delimiter?.value,
      minDeposit: this.minDeposit?.value,
      preKycMaxDeposit: this.preKycMaxDeposit?.value,
      minOrder: this.minOrder?.value,
      preKycMaxOrder: this.preKycMaxOrder?.value,
      minWithdraw: this.minWithdraw?.value,
      preKycMaxWithdraw: this.preKycMaxWithdraw?.value
    };

    this.api.createCurrency(newCurrency).subscribe({
      next: (res) => {
        this.currencies.push(res.data!);
        this.currencyForm.reset({ isActive: true });
        this.notifyService.showSuccess("Currency added successfully", "Success")
      },
      error: (err) => {
        this.notifyService.showError(err.error?.Error?.Details || 'Failed to create currency', "Error");
      }
    });
  }

  getStatusClass(status: string): string {
    return this.format.getGeneralStatusClass(status, true);
  }

  openCurrencyModal(currency: CurrencyDetailsDto) {
    this.selectedCurrency = currency;

    const el = document.getElementById('currencyDetailsModal');
    if (!el) return;

    this.currencyModal = Modal.getOrCreateInstance(el);
    this.currencyModal.show();
  }

  closeCurrencyModal() {
    this.currencyModal?.hide();
    this.selectedCurrency = null;
  }
}
